// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3OkCH","right":"Footer_right__33AaJ","buttons":"Footer_buttons__2CzU8"};